//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import React from 'react';
import styled, { css } from 'styled-components';

import { Mixins } from '@theme/mixins';

/**
 * The VisuallyHiddenText atom renders text that is completely invisible to sighted readers,
 * but properly read by screen readers on all browsers. It should be used to provide additional
 * context to user interfaces build with visual context, such as search bars labeled with a visual
 * search icon or graphs.
 *
 * For more information on this approach, see this article: https://snook.ca/archives/html_and_css/hiding-content-for-accessibility
 */
const VisuallyHiddenText: React.FunctionComponent = ({ children }) => {
  return <Hidden>{children}</Hidden>;
};

const Hidden = styled.div(
  () => css`
    ${Mixins.VisuallyHidden}
  `,
);

export default VisuallyHiddenText;
